import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';
import * as getTime from '~/skills/getTime';
import * as getStatus from '~/skills/getStatus';
import PageTitle from '~/components/PageTitle';
import SearchBar from '~/components/SearchBar';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
// import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Input, EAA_ErrorText, EAA_Upload, EAA_Status, EAA_UpdateTime, EAA_BottomBtn } from '~/components/EditAndAddItem';
import Sub1 from './Sub1';

const modeInfo = {
  add: {
    title: '行政程序新增',
  },
  edit: {
    title: '行政程序編輯',
  },
  view: {
    title: '行政程序檢視',
  },
};

class AddAndEdit extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }
  componentDidMount () {
    const { id, getBaseData, getAProIdDetail, mode = '', setPageText } = this.props;
    setPageText(modeInfo[mode].title);
    getBaseData();
    if (mode !== 'add')getAProIdDetail(id);
  }

  componentDidUpdate (preProps) {
    const { AProIdDetail: preAProIdDetail = {} } = preProps;
    const { AProIdDetail = {}, mode } = this.props;
    if (Object.keys(preAProIdDetail).length === 0 && Object.keys(AProIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: AProIdDetail, old_data: JSON.parse(JSON.stringify(AProIdDetail)) });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('AProIdDetail');
    clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });

  getSendBody=() => {
    const { data } = this.state;
    const body = {
      proc_type: data.proc_type || '',
      apply_status: data.apply_status || '',
      reserve_apply_date: data.reserve_apply_date || '',
      reserve_get_date: data.reserve_get_date || '',
      actual_apply_date: data.actual_apply_date || '',
      actual_get_date: data.actual_get_date || '',
      ischange: data.ischange || '',
      get_extend_agree_date: data.get_extend_agree_date || '',
      wind_mechine_allmw: data.wind_mechine_allmw || '',
      upload_offical_doc_type: data.upload_offical_doc_type || '',
      sub1: data.sub1 || [],
      actual_apply_upload_files: data.actual_apply_upload_files || [],
      actual_get_upload_files: data.actual_get_upload_files || [],
      change_upload_files: data.change_upload_files || [],
      get_extend_upload_files: data.get_extend_upload_files || [],
      upload_imgs: data.upload_imgs || [],
      upload_files: data.upload_files || [],

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  edit=(status = {}) => {
    this.setState({ canSend: false });
    const { id, putAProIdDetail } = this.props;
    const body = { ...this.getSendBody(), ...status };
    putAProIdDetail(id, { ...body, change_reason: '變更原因' });
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.proc_type) === '', // 0 程序文件
      returnInputValue(data.apply_status) === '', // 1 申請狀態
      (data.apply_status === '尚未申請') && (returnInputValue(data.reserve_apply_date) === ''), // 2 預定申請時間
      (data.apply_status === '尚未申請') && (returnInputValue(data.reserve_get_date) === ''), // 3 預定取得時間
      (data.apply_status === '申請中') && (returnInputValue(data.actual_apply_date) === ''), // 4 實際提送申請公文時間
      (data.apply_status === '申請中') && ((data.actual_apply_upload_files || []).length === 0), // 5 上傳申請公文
      (data.apply_status === '申請完成') && (returnInputValue(data.actual_get_date) === ''), // 6 實際取得許可時間
      (data.apply_status === '申請完成') && ((data.actual_get_upload_files || []).length === 0), // 7 上傳取得許可公文
      returnInputValue(data.ischange) === '', // 8 是否變更
      (data.ischange === '1') && ((data.change_upload_files || []).length === 0), // 9 上傳變更同意函文件
      false, // 10 取得展延同意時間 非必填
      false, // 11 上傳展延同意函公文 非必填
      false, // 12 風力機單機容量 容量
      false, // 13 風力機單機容量 組數
      false, // 14 水下基礎形式
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { aProApplyStatusList = [], aProTypeList = [], mode = '' } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck || (!getStatus.canEdit(data));
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const checkFilesChange = label => isCheck ? JSON.stringify(data[label] || []) !== JSON.stringify(old_data[label] || []) : false;
    const checkSubChange = (n, ary = []) => isCheck ? JSON.stringify(data[`sub${n}`] || ary) !== JSON.stringify(old_data[`sub${n}`] || ary) : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;
    const titleWidth = 170;
    const errorLeft = 20 + titleWidth;
    const statusAry = [];
    aProApplyStatusList.forEach(element => {
      if ((element.name !== '已展延') || (data.proc_type === '電業籌設許可') || (data.proc_type === '電業施工許可')) {
        statusAry.push(element);
      }
    });
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 8 }} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='程序文件' bol={true} haveChange={checkChange('proc_type')} />
              <EAA_Select displayBorder disabled list={aProTypeList} value={returnInputValue(data.proc_type)} onChange={data => { this.changeData({ label: 'proc_type', data }); }} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='申請狀態' bol={true} haveChange={checkChange('apply_status')} />
              <EAA_Select displayBorder disabled={disabled} list={statusAry} value={returnInputValue(data.apply_status)} onChange={data => { this.changeData({ label: 'apply_status', data }); }} />
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
        </EAA_Row>

        {(data.apply_status === '尚未申請') && (
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='預定申請時間' bol={true} haveChange={checkChange('reserve_apply_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.reserve_apply_date)} onChange={data => this.changeData({ label: 'reserve_apply_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇時間' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='預定取得時間' bol={true} haveChange={checkChange('reserve_get_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.reserve_get_date)} onChange={data => this.changeData({ label: 'reserve_get_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇時間' />}
            </EAA_Item>
          </EAA_Row>
        )}

        {(data.apply_status === '申請中') && (
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='實際提送申請公文時間' subtitle='(依公文時間)' bol={true} haveChange={checkChange('actual_apply_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.actual_apply_date)} onChange={data => this.changeData({ label: 'actual_apply_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇時間' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='上傳申請公文' bol={true} haveChange={checkFilesChange('actual_apply_upload_files')} />
                <EAA_Upload displayBorder disabled={disabled} value={data.actual_apply_upload_files || []} onChange={data => this.changeData({ label: 'actual_apply_upload_files', data })} />
              </EAA_ItemContainer>
              {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳' />}
            </EAA_Item>
          </EAA_Row>
        )}

        {(data.apply_status === '申請完成') && (
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='實際取得許可時間' subtitle='(依許可公文日期)' bol={true} haveChange={checkChange('actual_get_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.actual_get_date)} onChange={data => this.changeData({ label: 'actual_get_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇時間' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='上傳取得許可公文' bol={true} haveChange={checkFilesChange('actual_get_upload_files')} />
                <EAA_Upload displayBorder disabled={disabled} value={data.actual_get_upload_files || []} onChange={data => this.changeData({ label: 'actual_get_upload_files', data })} />
              </EAA_ItemContainer>
              {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳' />}
            </EAA_Item>
          </EAA_Row>
        )}

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='是否變更' bol={true} haveChange={checkChange('ischange')} />
              <CircleCheckBox disabled={disabled} value={data.ischange === '0'} onClick={() => this.changeData({ label: 'ischange', data: '0' })} />
              <div style={{ marginRight: 8 }}>否</div>
              <CircleCheckBox disabled={disabled} value={data.ischange === '1'} onClick={() => this.changeData({ label: 'ischange', data: '1' })} />
              <div>是</div>
            </EAA_ItemContainer>
            {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
          </EAA_Item>
          {data.ischange === '1' && (
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='上傳變更同意函文件' bol={true} haveChange={checkFilesChange('change_upload_files')} />
                <EAA_Upload displayBorder disabled={disabled} value={data.change_upload_files || []} onChange={data => this.changeData({ label: 'change_upload_files', data })} />
              </EAA_ItemContainer>
              {errorAry[9] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳' />}
            </EAA_Item>
          )}
        </EAA_Row>

        {((data.apply_status === '已展延') && ((data.proc_type === '電業籌設許可') || (data.proc_type === '電業施工許可'))) && (
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='取得展延同意時間' haveChange={checkChange('get_extend_agree_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.get_extend_agree_date)} onChange={data => this.changeData({ label: 'get_extend_agree_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {/* {errorAry[0] && <EAA_ErrorText  marginLeft={errorLeft} text='帳號需為 1 ~ 100 英數字。' />} */}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='上傳展延同意函公文' haveChange={checkFilesChange('get_extend_upload_files')} />
                <EAA_Upload displayBorder disabled={disabled} value={data.get_extend_upload_files || []} onChange={data => this.changeData({ label: 'get_extend_upload_files', data })} />
              </EAA_ItemContainer>
              {/* {errorAry[0] && <EAA_ErrorText  marginLeft={errorLeft} text='帳號需為 1 ~ 100 英數字。' />} */}
            </EAA_Item>
          </EAA_Row>
        )}

        {/* <EAA_Row>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#5597b4' }}>施工許可風機資訊</div>
        </EAA_Row> */}
        { (data.proc_type === '電業施工許可') && (
          <SearchBar style={{ marginTop: 8 }} text='施工許可風機資訊' defaultOpen>
            <Sub1 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='總容量' haveChange={checkChange('wind_mechine_allmw')} />
                  <EAA_Input displayBorder disabled={disabled} type='number' unit='MW' value={data.wind_mechine_allmw} onChange={data => this.changeData({ label: 'wind_mechine_allmw', data })} />
                </EAA_ItemContainer>
              </EAA_Item>
              <EAA_Item>
                <EAA_ItemContainer>
                  <div style={{ marginRight: 12 }}>上傳示意圖</div>
                  <EAA_Upload displayBorder disabled={disabled} hint='上傳示意圖(必填)' value={data.upload_imgs || []} onChange={data => this.changeData({ label: 'upload_imgs', data })} marginRight={12} />
                  <div style={{ marginRight: 12 }}>上傳座標檔</div>
                  <EAA_Upload displayBorder disabled={disabled} hint='上傳座標檔(必填)' value={data.upload_files || []} onChange={data => this.changeData({ label: 'upload_files', data })} />
                </EAA_ItemContainer>
              </EAA_Item>
            </EAA_Row>
          </SearchBar>
        )}

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='上傳公文類型' bol={true} haveChange={checkChange('upload_offical_doc_type')} />
              <CircleCheckBox disabled={disabled} value={data.upload_offical_doc_type === '1'} onClick={() => this.changeData({ label: 'upload_offical_doc_type', data: '1' })} />
              <div style={{ marginRight: 8 }}>同意函</div>
              <CircleCheckBox disabled={disabled} value={data.upload_offical_doc_type === '2'} onClick={() => this.changeData({ label: 'upload_offical_doc_type', data: '2' })} />
              <div>原則同意函</div>
            </EAA_ItemContainer>
            {/* {errorAry[0] && <EAA_ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
          </EAA_Item>
        </EAA_Row>

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          {...{
            data,
            mode,
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: () => {},
            edit: this.edit,
          }}
        />

        {/* <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewUser' /> */}
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutAProIdDetail' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  aProApplyStatusList: state.data.AProApplyStatusList,
  aProTypeList: state.data.AProTypeList,
  AProIdDetail: state.data.AProIdDetail,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getBaseData: () => {
    Actions_Wind.getAProApplyStatusList(dispatch);
    Actions_Wind.getAProTypeList(dispatch);
    Actions_Wind.getAProUnderWaterList(dispatch);
  },
  getAProIdDetail: id => Actions_Wind.getAProIdDetail(dispatch, { id }),
  // postAddNewUser: body => Actions.postAddNewUser(dispatch, { body }),
  putAProIdDetail: (id, body) => Actions_Wind.putAProIdDetail(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
